import getQueryString from "./getQueryString";
import languageList from "./language";
import { Icon } from "antd";
const pageSize = 10;
const escapeUserName = (account,areaCode = "86") => {
  if (account.indexOf("@")<=-1) {
    return areaCode + account;
  } else {
    return account;
  }
};

export { getQueryString, pageSize, escapeUserName,languageList };
